import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

interface ManageSubscriptionCardProps {
  onManage?: () => void;
}

export const ManageSubscriptionCard = ({
  onManage,
}: ManageSubscriptionCardProps) => {
  const { t } = useTranslations();

  return (
    <div className="flex h-[144px] w-full max-w-[1000px] items-center justify-between rounded-[18px] border border-solid border-dark-100 bg-white px-8">
      <div className="flex flex-col gap-1">
        <span className="font-secondary text-xl leading-[33px] font-semibold text-dark">
          {t({
            id: "cx-plans-page.manage-subscription-card.title",
            defaultMessage: "Manage Subscription",
          })}
        </span>
        <span className="max-w-[520px] font-secondary text-sm leading-[21px] text-dark-700">
          {t({
            id: "cx-plans-page.manage-subscription-card.description",
            defaultMessage:
              "Get Invoices, update your payment method, and adjust your subscription in Stripe",
          })}
        </span>
      </div>

      <Button variant="primary" iconEnd={<ArrowRightIcon />} onClick={onManage}>
        {t({
          id: "cx-plans-page.manage-subscription-card.button",
          defaultMessage: "Manage Subscription",
        })}
      </Button>
    </div>
  );
};
